/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Геоподсказка
 */
export type SuggestionSuggestItem = {
  /**
   * Вариант найденного значения
   */
  address: string
  /**
   * Уровень объекта
   */
  level: SuggestionSuggestItem.Level
  /**
   * Идентификатор объекта Яндекс.Карт
   */
  uri: string
}
export namespace SuggestionSuggestItem {
  /**
   * Уровень объекта
   */
  export enum Level {
    STREET = 'street',
    _HOUSE = ' house'
  }
}
